export default {
  zh: {
    add: '添加',
    action: '操作',
    tokenName: '令牌名称',
    apiToken: 'API 令牌',
    createdDate: '创建时间',
    expireDate: '有效期至',
    addToken: '添加 API 令牌',
    saveToken: '保存',
    cancel: '取消',
    tokenLength: "名称长度不能超过10字",
    lengthError: '令牌列表不能超过20个',
    error: '令牌添加失败',
    updateError: '令牌更新失败'
  },
  en: {
    add: 'Add',
    action: 'Action',
    tokenName: 'Token Name',
    apiToken: 'API Token',
    createdDate: 'Created Time',
    expireDate: 'Expiration',
    addToken: 'Add API Token',
    saveToken: 'Save',
    cancel:'Cancel',
    tokenLength: 'The maximum length of name is 20 characters',
    lengthError: 'The maximum length of Token List is 20',
    error: 'Token add error',
    updateError: 'Token update error'
  }
};



// WEBPACK FOOTER //
// ./src/views/Setup/ApiToken/i18n.js